module.exports = __webpack_public_path__ + "6fa427f1cdf0bab7ddcde3b65dc02a1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ServeInformation/Assets/meatserve.png
// module id = 1368
// module chunks = 0